import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { HashRouter as Router } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import './language/i18n';
import store from "../src/app/store";
import axios from "axios";
import swal from "sweetalert";

// Cấu hình interceptor response toàn cục để xử lý phiên hết hạn hoặc đăng nhập từ nơi khác
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 403) {
            const data = error.response.data;
            const message = data?.data?.tokenVerificationData?.message || data?.message || "";
            
            if (localStorage.getItem("user")) {
                localStorage.removeItem("user");
                localStorage.removeItem("profile");
                localStorage.removeItem("data");
                localStorage.removeItem("currentUser");
                localStorage.removeItem("data1");
                document.cookie = "jwt=;Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                
                if (message === "Tài khoản đã được đăng nhập từ thiết bị khác!") {
                    swal({
                        title: "Thông báo",
                        text: "Tài khoản của bạn đã được đăng nhập từ thiết bị khác!",
                        icon: "warning",
                        buttons: "Đăng nhập lại"
                    }).then(() => {
                        window.location.href = "/login";
                    });
                } else {
                    // Hết hạn hoặc lý do khác: tự động đẩy về trang login
                    window.location.href = "/login";
                }
            }
        }
        return Promise.reject(error);
    }
);

ReactDOM.createRoot(document.getElementById("root")).render(
    <Provider store={store}>
        <React.Suspense fallback={<div className="admin-theme">...</div>}>
        <AnimatePresence wait>
            <Router>
                <App />
            </Router>
            </AnimatePresence>
        </React.Suspense>
    </Provider>
);
reportWebVitals();